import { useCodesStore } from '@/ContextTab/stores/codes'
import { useProfileCodesStore } from '@/ContextTab/stores/profileCodes'
import { prepareCanvasCodes, processCodesForLegacy } from '@/lib/processDataForLegacy'


export async function usePassCodes() {

  const codesStore = useCodesStore()
  const profileCodesStore = useProfileCodesStore()

  return async (legacyApp: any) => {

    legacyApp.$store.commit(
      'news/codes/CODES_SET_ALL',
      processCodesForLegacy(codesStore.codeTree),
    )

    legacyApp.$store.commit('news/codes/CODES_SET_PROFILE', {
      typeName: 'NEWS_OR_ISSUE',
      codes: processCodesForLegacy(profileCodesStore.newsCreationCodes),
    })

    legacyApp.$store.commit('news/codes/CODES_SET_PROFILE', {
      typeName: 'PUBLISH_NEWS',
      codes: processCodesForLegacy(profileCodesStore.newsPublicationCodes),
    })

    legacyApp.$store.commit(
      'news/codes/CODES_SET_CANVAS_CODES',
      prepareCanvasCodes(
        profileCodesStore.newsCreationCodes,
        profileCodesStore.newsPublicationCodes,
      ),
    )

    legacyApp.$store.commit('news/codes/CODES_INIT', 2)
  }
}
